import { createContext, useContext, useState } from "react";

const DetailModalContext = createContext({
  item: null,
  openDetail: () => {},
  closeDetail: () => {},
});

export const DetailModalProvider = ({ children }) => {
  const [item, setItem] = useState(null);
  const openDetail = (i) => setItem(i);
  const closeDetail = () => setItem(null);
  return (
    <DetailModalContext.Provider value={{ item, openDetail, closeDetail }}>
      {children}
    </DetailModalContext.Provider>
  );
};

export const useDetailModal = () => useContext(DetailModalContext);
